import React from "react";
import { dateFilterDates } from "../helpers";
import { SelectChangeEvent } from "@mui/material";

export type DateTypes =
  | "today"
  | "yesterday"
  | "lastWeek"
  | "thisWeek"
  | "thisMonth"
  | "last30Days"
  | "allTimes"
  | "custom";

export interface IDate {
  fromDate: string;
  toDate: string;
}

export const useDateFilter = ({
  format,
  defaultType = "last30Days",
}: {
  format?: string;
  defaultType?: DateTypes;
}) => {
  const {
    today,
    tomorrow,
    lastweek,
    startDateOfMonth,
    last30Days,
    yesterday,
    thisWeekStartDate,
    thisWeekEndDate,
  } = dateFilterDates(format);
  const [date, setDate] = React.useState({
    ...getInitialDate(defaultType, format),
  });
  const [type, setType] = React.useState(defaultType);

  const updateDate = (type: DateTypes) => {
    if (type === "today") {
      setDate({ fromDate: today, toDate: today });
    } else if (type === "yesterday") {
      setDate({ fromDate: yesterday, toDate: yesterday });
    } else if (type === "lastWeek") {
      setDate({ fromDate: lastweek, toDate: today });
    } else if (type === "thisMonth") {
      setDate({ fromDate: startDateOfMonth, toDate: today });
    } else if (type === "last30Days") {
      setDate({ fromDate: last30Days, toDate: today });
    } else if (type === "thisWeek") {
      setDate({ fromDate: thisWeekStartDate, toDate: thisWeekEndDate });
    } else if (type === "allTimes") {
      setDate({ fromDate: "", toDate: "" });
    }
    setType(type as DateTypes);
  };

  const handleDateSelectChange = (e: SelectChangeEvent<unknown>) => {
    const value = e.target.value as DateTypes;
    updateDate(value);
  };

  const dateDropdownList = React.useMemo(() => {
    return [
      { label: "Today", value: "today" },
      { label: "Yesterday", value: "yesterday" },
      { label: "Last Week", value: "lastWeek" },
      { label: "This Week", value: "thisWeek" },
      { label: "This Month", value: "thisMonth" },
      { label: "Last 30 Days", value: "last30Days" },
      { label: "All Times", value: "allTimes" },
      { label: "Customize", value: "custom" },
    ];
  }, []);

  return {
    date,
    setDate,
    type,
    handleDateSelectChange,
    updateDate,
    dateDropdownList,
  };
};

const getInitialDate = (type: DateTypes, format?: string) => {
  const {
    today,
    lastweek,
    startDateOfMonth,
    yesterday,
    last30Days,
    thisWeekStartDate,
    thisWeekEndDate,
  } = dateFilterDates(format);

  if (type === "yesterday") {
    return { fromDate: yesterday, toDate: yesterday };
  } else if (type === "today") {
    return { fromDate: today, toDate: today };
  } else if (type === "lastWeek") {
    return { fromDate: lastweek, toDate: today };
  } else if (type === "thisMonth") {
    return { fromDate: startDateOfMonth, toDate: today };
  } else if (type === "last30Days") {
    return { fromDate: last30Days, toDate: today };
  } else if (type === "thisWeek") {
    return { fromDate: thisWeekStartDate, toDate: thisWeekEndDate };
  } else if (type === "allTimes") {
    return { fromDate: "", toDate: "" };
  }
  // Default fallback to last30Days
  return { fromDate: last30Days, toDate: today };
};
